import React from 'react';
import './style.css';

class Privacidad extends React.Component {

	constructor(props) {
		super(props)
		this.state = {}
	}

	componentDidMount() {
        document.title ="Ki Systems | Aviso de Privacidad";
        document.getElementsByTagName("html")[0].classList = "";
        document.getElementsByTagName("html")[0].classList.add("stylePrivacidad");
	}

	render() {
		return(
			<React.Fragment>
				<div class="aviso-privacidad-container">
                <div class="aviso-header">
                    <h1>Aviso de Privacidad</h1>
                    <p>Ki Systems &bull; Cumplimiento de la Ley Federal de Protección de Datos Personales</p>
                </div>

                <div class="aviso-legal-box">
                    <p><strong>Responsable de la protección de sus datos personales:</strong><br/>
                    <strong>Pablo Cerón Cervantes</strong>, operando comercialmente bajo la marca registrada <strong>Ki Systems</strong>, con domicilio fiscal en 38 Norte Núm. Ext. 406, Núm. Int. 9, Col. Santa Bárbara Norte, C.P. 72380, Puebla, Puebla, México, es responsable del tratamiento de sus datos personales conforme a lo dispuesto por la Ley Federal de Protección de Datos Personales en Posesión de los Particulares (LFPDPPP).</p>
                </div>

                <h2>1. Datos Personales Recabados</h2>
                <p>Para llevar a cabo las finalidades descritas en el presente aviso de privacidad, recabaremos las siguientes categorías de datos personales directamente a través de nuestro sitio web oficial o canales de contacto autorizados:</p>
                <ul>
                    <li><strong>Datos de identificación:</strong> Nombre completo.</li>
                    <li><strong>Datos de contacto:</strong> Correo electrónico y número telefónico.</li>
                    <li><strong>Datos comerciales (opcional):</strong> Nombre de la escuela, club o institución de artes marciales.</li>
                </ul>

                <h2>2. Finalidades del Tratamiento de los Datos</h2>
                <p>Los datos personales que recabamos de usted serán utilizados para las siguientes finalidades primarias, las cuales son necesarias para el servicio o producto que solicita:</p>
                <ul>
                    <li>Verificar y confirmar su identidad como cliente o usuario interesado.</li>
                    <li>Proveer y licenciar las soluciones de software de jueceo y puntuación de Ki Systems (incluyendo SMTKD y SMAK).</li>
                    <li>Brindar soporte técnico especializado y actualizaciones.</li>
                    <li>Emitir la facturación y comprobantes fiscales correspondientes.</li>
                </ul>
                <p>De manera secundaria, utilizaremos su información para fines de prospección comercial, envío de ofertas y lanzamientos de nuevos productos. Si no desea que sus datos sean tratados para estas finalidades secundarias, puede solicitarlo enviando un correo al contacto indicado en la sección 4.</p>

                <h2>3. Transferencia de Datos</h2>
                <p>Ki Systems no realiza transferencias de sus datos personales a terceros, nacionales o extranjeros, salvo aquellas excepciones previstas por el artículo 37 de la LFPDPPP, o cuando sea estrictamente necesario para cumplir con obligaciones legales.</p>

                <h2>4. Derechos ARCO</h2>
                <p>Usted tiene derecho a conocer qué datos tenemos (Acceso), solicitar su corrección (Rectificación), pedir que los eliminemos (Cancelación) oponerse a su uso (Oposición). Para ejercer estos derechos o revocar su consentimiento, envíe un correo electrónico a: <strong>contacto@kisystems.com.mx</strong>.</p>
                <p>La respuesta a su solicitud se emitirá en un plazo máximo de 20 días hábiles.</p>

                <h2>5. Cambios al Aviso de Privacidad</h2>
                <p>Cualquier modificación o actualización a este aviso de privacidad estará disponible de manera permanente a través de nuestro sitio web oficial <strong>www.kisystems.com.mx</strong>.</p>
                
                <div class="aviso-footer-note">
                    <p>Última actualización: Mayo de 2026</p>
                </div>
            </div>
			</React.Fragment>
		);
	}

}

export default Privacidad;